/**
 * 格式化url
 * @param url url路径
 * @returns string 格式化后的path
 */
export const formatUrl = (url: string) => {
  if (!url) {
    return '';
  }
  if (url.startsWith('http')) {
    const path = new URL(url).pathname;
    return path;
  }
  return url;
};

/**
 * 格式化url
 * @param url url路径
 * @returns string 格式化后的path
 */
export const getOrigin = (url: string) => {
  if (!url) {
    return '';
  }
  if (url.startsWith('http')) {
    const origin = new URL(url).origin;
    return origin;
  }
  return url;
};
